import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import Loading from '../../SharedComponents/Loading';
import Photograph from '../../SharedComponents/Svg/Photograph';
import { getSharedKhareefPhotos, errorMessage, STATUS } from './ApiKhareefPhotos';
import KhareefHero from './components/KhareefHero';
import KhareefPosters from './components/KhareefPosters';
import { BRAND } from './components/KhareefBrand';

export default function KhareefPhotos() {
  const { t } = useTranslation();
  const { data, isLoading, isError, error } = useQuery(
    ['khareefSharedPhotos'],
    getSharedKhareefPhotos,
    { refetchOnMount: true },
  );

  if (isLoading) return <Loading />;
  if (isError)
    return <div className="text-red-600">{t(errorMessage(error)) || t('Something went wrong')}</div>;

  // The public page only shows photos that have been published (step 6).
  const photos = (data?.data ?? []).filter((p) => p.status === STATUS.PUBLISHED);

  return (
    <>
      <header className="flex justify-end items-center mb-4">
        <Link
          to="/khareef-photos/manage"
          className="bg-blackv2 hover:bg-blackv1 text-white text-sm rounded px-4 py-2"
        >
          {t('Manage Submissions')}
        </Link>
      </header>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <KhareefHero />

        <div className="px-8 py-8" dir="rtl">
          {/* Section heading */}
          <h2 className="text-xl font-bold mb-6 text-right" style={{ color: BRAND.purple }}>
            الصور المشاركة
          </h2>

          {/* Share-your-photo CTA, same copy as the portal's share card */}
          <div className="bg-gray-100 rounded-2xl flex flex-col items-center justify-center text-center py-10 px-6 mb-10">
            <p className="text-base md:text-lg font-medium mb-5" style={{ color: BRAND.teal }}>
              شاركنا لحظاتك المميزة في خريف ظفار وكن جزءاً من قصة الموسم
            </p>
            <span
              className="inline-flex items-center gap-2 rounded-full px-8 py-3 font-bold"
              style={{ backgroundColor: BRAND.yellow, color: BRAND.purple }}
            >
              شارك الآن
              <span className="text-sm font-medium opacity-80">Share now</span>
            </span>
          </div>

          {/* Gallery grid */}
          {photos.length === 0 ? (
            <div className="flex flex-col items-center text-gray-400 py-16">
              <Photograph className="w-12 h-12" />
              <span className="mt-3">لا توجد صور منشورة حالياً، كن أول المشاركين!</span>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 bg-gray-200">
              {photos.map((photo) => (
                <div key={photo.id} className="relative group overflow-hidden">
                  <img
                    src={photo.url}
                    alt={photo.participant}
                    className="w-full h-56 object-cover transform group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent text-white text-sm px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    {photo.location}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Campaign posters, as at the foot of the public page */}
          <div className="mt-12">
            <KhareefPosters />
          </div>
        </div>
      </div>
    </>
  );
}
